// extracted by mini-css-extract-plugin
export default {"container":"footer_container__8t-Fj","link":"footer_link__fZx+G","spacer":"footer_spacer__fae3p"};